import { render, staticRenderFns } from "./SigninLayout.vue?vue&type=template&id=74c74c99"
import script from "./SigninLayout.vue?vue&type=script&lang=js"
export * from "./SigninLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports